<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <OperationForm :formProps="formProps">
                </OperationForm>
            </template>
            <template #search="searchProps">
                <OperationSearch :searchProps="searchProps">
                </OperationSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { router } from '@inertiajs/vue3'
import OperationForm from './OperationForm.vue'
import OperationSearch from './OperationSearch.vue'

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

const rowButtonAction = async function (item, rowData) {
    router.visit(route('statement-index', { operation_id: rowData.id }), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// //------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
